import {TASK_RECURRENCE} from "../../../../model2/recurrence/const"
import {MenuOption} from "../../../../gd-components/popover-menu/popover-menu/const"
import {TaskAction} from "../@const"
import Task from "../../../../model2/task/task"

export type Props = {
    task                : Task

    hiddenActions?      : TaskAction[],
    disabledActions?    : string[]
}

export function taskMore_initRecurrence(props: Props, menuOptions:MenuOption[], isTemplate: boolean) {

    const task = props.task

    if (props.hiddenActions?.includes(TaskAction.EDIT_RECURRENCE)) return

    const onClickRecurrence = () => {
        const taskId = task.recurrency ? task.recurrency.parentTaskId : task.id
        gd.modals.other.recurrence(TASK_RECURRENCE, taskId)
    }

    const onClickPro = () => {
        gd.modals.other.upgradeToPro(gd.companyId)
    }

    const recurrenceDisabled = isTemplate || props.disabledActions?.includes('recurring') || !task.acl.canAddRecurrence
    if (!gd.company.license.isPro) {
        menuOptions.push({
            icon            : "i5-recurrence",
            label           : "Make recurring",
            onClickUpgrade  : onClickPro,
            disabled        : recurrenceDisabled,
            isPro           : true
        })
    } else {
        if (task.recurrency) {
            menuOptions.push({
                icon        : "i5-recurrence",
                label       : "Edit recurrence",
                onClick     : onClickRecurrence,
                disabled    : recurrenceDisabled
            })
        } else {

            if (gd.const.systemStatus.isOpen(task.systemStatus)) {
                menuOptions.push({
                    icon        : "i5-recurrence",
                    label       : "Make recurring",
                    onClick     : onClickRecurrence,
                    disabled    : recurrenceDisabled
                })
            } else {
                menuOptions.push({
                    icon        : "i5-recurrence",
                    label       : "Make recurring",
                    onClick     : onClickRecurrence,
                    disabled    : true
                })
            }
        }
    }
}